import styled from '@material-ui/styles/styled';
import { Button } from '@vkontakte/vkui';
import { ButtonProps } from '@vkontakte/vkui/dist/components/Button/Button';

export default styled(Button)({
  '--button_tertiary_foreground': 'var(--button_secondary_foreground)',
}) as React.FC<ButtonProps>;
